<div class="table-responsive table-list">
  <table class="table table-striped table-sm table-bordered table-hover bsg-table result-list">
    <thead>
      <tr>
        <th class="text-center element-number">
          @if (notApplicablePointGroupsDisplayed) {
            <button
              ngbPopover="{{ 'NZ-Punktegruppen ausblenden' | translate }}"
              placement="right"
              triggers="mouseenter:mouseleave"
              class="btn btn-link btn-expand"
              (click)="onNotApplicablePointGroupsDisplayedChanged()">
              <span class="fas fa-angle-double-left"></span>
            </button>
          }
          @if (!notApplicablePointGroupsDisplayed) {
            <button
              ngbPopover="{{ 'NZ-Punktegruppen einblenden' | translate }}"
              placement="right"
              triggers="mouseenter:mouseleave"
              class="btn btn-link btn-expand"
              (click)="onNotApplicablePointGroupsDisplayedChanged()">
              <span class="fas fa-angle-double-right"></span>
            </button>
          }
        </th>
        <th colspan="3">
          <h3>
            @if (categoryDetail.categoryName) {
              <span>{{ categoryDetail.categoryName | i18nText }}</span>
            }
            <span>&nbsp;({{ categoryDetail.categoryNumber }})</span>
          </h3>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (listItem of list.items; track listItem) {
        @if (
          listItem.pointGroup && listItem.pointGroup.pointGroupType === pointGroupTypes.Regular
        ) {
          <tr class="detail-list-regular-point-group">
            <td class="text-center">{{ listItem.pointGroup.pointGroupNumber }}</td>
            <td
              (click)="
                hasDescription(listItem.pointGroup.pointGroupDescription) &&
                  (listItem.pointGroup.pointGroupDescriptionDisplayed =
                    !listItem.pointGroup.pointGroupDescriptionDisplayed)
              "
              class="list-point-group-name list-name"
              [ngClass]="{ clickable: hasDescription(listItem.pointGroup.pointGroupDescription) }"
              [attr.aria-expanded]="listItem.pointGroup.pointGroupDescriptionDisplayed"
              [attr.aria-controls]="listItem.pointGroup.pointGroupNumber">
              @if (hasDescription(listItem.pointGroup.pointGroupDescription)) {
                <span class="description-icon fas fa-info-circle"></span>
              }
              <div>{{ listItem.pointGroup.pointGroupName | i18nText }}</div>
              <div
                id="{{ listItem.pointGroup.pointGroupNumber }}"
                [ngbCollapse]="!listItem.pointGroup.pointGroupDescriptionDisplayed">
                <i class="element-description">{{
                  listItem.pointGroup.pointGroupDescription | i18nText
                }}</i>
              </div>
            </td>
            <td class="text-center detail-list-value">
              @if (!hasOnlyFieldValuePoints(listItem.pointGroup)) {
                <app-detail-result-dropdown
                  (resultChange)="onPointGroupResultChanged(listItem)"
                  [result]="listItem.pointGroup.pointGroupResult"
                  [resultType]="listItem.pointGroup.pointGroupResult.inspectionResult"
                  [dependingResults]="getDependingResultsForPointGroup(listItem.pointGroup)"
                  [displayDefectOption]="false"
                  [displayEditRemark]="false"
                  [readonly]="readonly"
                  [elementName]="listItem.pointGroup.pointGroupName"></app-detail-result-dropdown>
              }
            </td>
            <td class="detail-list-filler"></td>
          </tr>
        }
        @if (
          listItem.pointGroup &&
          listItem.pointGroup.pointGroupType === pointGroupTypes.SubheadWithoutDataEntry
        ) {
          <tr class="detail-list-subhead-point-group">
            <td class="text-center">{{ listItem.pointGroup.pointGroupNumber }}</td>
            <td
              (click)="
                hasDescription(listItem.pointGroup.pointGroupDescription) &&
                  (listItem.pointGroup.pointGroupDescriptionDisplayed =
                    !listItem.pointGroup.pointGroupDescriptionDisplayed)
              "
              class="list-point-group-name list-name"
              [ngClass]="{ clickable: hasDescription(listItem.pointGroup.pointGroupDescription) }"
              [attr.aria-expanded]="listItem.pointGroup.pointGroupDescriptionDisplayed"
              [attr.aria-controls]="listItem.pointGroup.pointGroupNumber">
              @if (hasDescription(listItem.pointGroup.pointGroupDescription)) {
                <span class="description-icon fas fa-info-circle"></span>
              }
              <div>{{ listItem.pointGroup.pointGroupName | i18nText }}</div>
              <div
                id="{{ listItem.pointGroup.pointGroupNumber }}"
                [ngbCollapse]="!listItem.pointGroup.pointGroupDescriptionDisplayed">
                <i class="element-description">{{
                  listItem.pointGroup.pointGroupDescription | i18nText
                }}</i>
              </div>
            </td>
            <td class="text-center">
              @if (getDependingResultsForPointGroup(listItem.pointGroup).length > 0) {
                <app-detail-result-dropdown
                  (resultChange)="rowPointGroupResultChanged(listItem)"
                  [result]="listItem.pointGroup.pointGroupResult"
                  [resultType]="listItem.pointGroup.pointGroupResult.inspectionResult"
                  [dependingResults]="getDependingResultsForPointGroup(listItem.pointGroup)"
                  [displayDefectOption]="true"
                  [displayEditRemark]="false"
                  [readonly]="readonly"></app-detail-result-dropdown>
              }
            </td>
            <td class="detail-list-filler"></td>
          </tr>
        }
        @if (listItem.point) {
          <tr class="detail-list-point">
            <td class="text-center">{{ listItem.point.pointNumber }}</td>
            <td
              class="list-point-name list-name"
              (click)="
                hasDescription(listItem.point.pointDescription) &&
                  (listItem.point.pointDescriptionDisplayed =
                    !listItem.point.pointDescriptionDisplayed)
              "
              [ngClass]="{ clickable: hasDescription(listItem.point.pointDescription) }"
              [attr.aria-expanded]="listItem.point.pointDescriptionDisplayed"
              [attr.aria-controls]="listItem.point.pointNumber">
              @if (hasDescription(listItem.point.pointDescription)) {
                <span class="description-icon fas fa-info-circle"></span>
              }
              <div>{{ listItem.point.pointName | i18nText }}</div>
              <div
                id="{{ listItem.point.pointNumber }}"
                [ngbCollapse]="!listItem.point.pointDescriptionDisplayed">
                <i class="element-description">{{ listItem.point.pointDescription | i18nText }}</i>
              </div>
            </td>
            <td class="text-center detail-list-value">
              <app-detail-list-point
                (resultChange)="onPointResultChanged(listItem)"
                [point]="listItem.point"
                [readonly]="readonly"
                [displayCopyFieldValueNumber]="displayCopyFieldValueNumber(listItem)"
                (copyValue)="onCopyFieldValueNumber(listItem)"></app-detail-list-point>
            </td>
            <td class="detail-list-value-remark">
              @if (displayRemark(listItem.point)) {
                <form-control (focusout)="onPointResultChanged(listItem)">
                  <input
                    name="remark"
                    [(ngModel)]="listItem.point.pointResult.remark"
                    type="text"
                    maxlength="2000"
                    [disabled]="readonly" />
                </form-control>
              }
            </td>
          </tr>
        }
      }
      @if (categoryDetail.displayCategoryResult) {
        <tr>
          <td
            colspan="2"
            (click)="
              hasDescription(list.summary.categoryDescription) &&
                (list.summary.categoryDescriptionDisplayed =
                  !list.summary.categoryDescriptionDisplayed)
            "
            class="list-category-name list-name"
            [ngClass]="{ clickable: hasDescription(list.summary.categoryDescription) }"
            [attr.aria-expanded]="list.summary.categoryDescriptionDisplayed"
            [attr.aria-controls]="categoryDetail.categoryNumber">
            @if (hasDescription(list.summary.categoryDescription)) {
              <span class="description-icon fas fa-info-circle"></span>
            }
            <h3>
              <span translate>Gesamtbeurteilung</span
              ><span>&nbsp;{{ categoryDetail.categoryName | i18nText }}</span>
            </h3>
            <div
              id="{{ categoryDetail.categoryNumber }}"
              [ngbCollapse]="!list.summary.categoryDescriptionDisplayed">
              <i class="element-description">{{ list.summary.categoryDescription | i18nText }}</i>
            </div>
          </td>
          <td class="text-center detail-list-value">
            <app-detail-category-result
              (resultChange)="onCategoryResultChanged($event)"
              [result]="list.summary.categoryResult"
              [resultType]="list.summary.categoryResult.inspectionResult"
              [hasDefects]="hasDefects"
              [readonly]="readonly"></app-detail-category-result>
          </td>
          <td class="detail-list-filler"></td>
        </tr>
      }
    </tbody>
  </table>
</div>
